"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var utilities_1 = require("../helpers/utilities");
var MenuDropdown = /** @class */ (function () {
    function MenuDropdown() {
        var _this = this;
        this.detectMouseOverElement = (0, utilities_1.debounce)(function (event) { return __awaiter(_this, void 0, void 0, function () {
            var target;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        target = event.target;
                        if (!(this.config.target !== target)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.update(target)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.config.target = target;
                        return [2 /*return*/];
                }
            });
        }); }, 250);
        this.config = {
            activePanel: null,
            previousPanel: null,
            target: null,
            isOpen: false,
            transitioning: false,
            slideout: null,
            transitionDuration: 200,
            htmlElements: {
                header: null
            },
            nodeLists: {
                main: null,
                panel: null
            },
            selectors: {
                main: '[data-menu-dropdown]',
                panel: '[data-menu-dropdown-panel]',
                header: '[data-header]'
            }
        };
    }
    MenuDropdown.prototype.init = function () {
        this.load();
        this.addEventListeners();
    };
    MenuDropdown.prototype.reinit = function () {
        this.load();
    };
    MenuDropdown.prototype.addEventListeners = function () {
        var _this = this;
        this.config.nodeLists.panel.forEach(function (htmlElement) { return htmlElement.addEventListener('mouseleave', _this.closeAll.bind(_this)); });
        document.addEventListener('mouseover', this.detectMouseOverElement.bind(this));
    };
    MenuDropdown.prototype.load = function () {
        this.config.nodeLists.main = document.querySelectorAll(this.config.selectors.main);
        this.config.nodeLists.panel = document.querySelectorAll(this.config.selectors.panel);
        this.config.htmlElements.header = document.querySelector(this.config.selectors.header);
    };
    MenuDropdown.prototype.open = function (htmlElement, delay) {
        var _this = this;
        this.closeAll();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (htmlElement) {
                    var currentMenu = htmlElement.dataset.menuDropdownPanel ? htmlElement.dataset.menuDropdownPanel : htmlElement.dataset.submenuOpen;
                    if (currentMenu) {
                        var currentMenuNodeList = document.querySelectorAll("[data-menu-dropdown=\"".concat(currentMenu, "\"],[data-submenu-open=\"").concat(currentMenu, "\"]"));
                        currentMenuNodeList.forEach(function (htmlElement) { return htmlElement.classList.add('menu-dropdown__link--open'); });
                    }
                    htmlElement.classList.add('menu-dropdown-panels__panel--open');
                    this.config.isOpen = true;
                }
                resolve();
            }.bind(_this, htmlElement), delay);
        });
    };
    MenuDropdown.prototype.close = function (htmlElement, delay) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (htmlElement) {
                    var currentMenuNodeList = document.querySelectorAll("[data-menu-dropdown],[data-submenu-open]");
                    currentMenuNodeList.forEach(function (htmlElement) { return htmlElement.classList.remove('menu-dropdown__link--open'); });
                    htmlElement.classList.remove('menu-dropdown-panels__panel--open');
                    this.config.isOpen = false;
                }
                resolve();
            }.bind(_this, htmlElement), delay);
        });
    };
    MenuDropdown.prototype.closeAll = function () {
        var _this = this;
        this.config.nodeLists.panel.forEach(function (panel) { return _this.close(panel, 0); });
    };
    MenuDropdown.prototype.update = function (target) {
        return __awaiter(this, void 0, void 0, function () {
            var main, panel, promoBar, isHovered;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        main = target.closest(this.config.selectors.main);
                        panel = main ? this.getActivePanel(main) : target.closest(this.config.selectors.panel);
                        promoBar = target.closest('[data-promo-bar]');
                        isHovered = panel || main || promoBar ? true : false;
                        if (isHovered) {
                            this.config.previousPanel = this.config.activePanel !== panel ? this.config.activePanel : null;
                            this.config.activePanel = main ? this.getActivePanel(main) : panel;
                        }
                        if (!(main && isHovered && this.config.previousPanel)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.close(this.config.previousPanel, 0)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.open(this.config.activePanel, 200)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!(main && isHovered)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.open(this.config.activePanel, 0)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        if (!isHovered) {
                            this.closeAll();
                            this.config.previousPanel = null;
                            this.config.activePanel = null;
                        }
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    MenuDropdown.prototype.getActivePanel = function (htmlElement) {
        return Array.from(this.config.nodeLists.panel).find(function (panel) { return panel.dataset.menuDropdownPanel === htmlElement.dataset.menuDropdown; });
    };
    return MenuDropdown;
}());
exports.default = new MenuDropdown();
